import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/group/allocatedHours/styles.scss';export default {
  "allocatedHours": "_allocatedHours_1tiwe_1",
  "edition": "_edition_1tiwe_7",
  "input": "_input_1tiwe_11",
  "text": "_text_1tiwe_31"
};